

/**
 * TODO 기왕 store로 뺀거 cache 개념을 도입할지 고민중...
 */

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  /*
  사용법
    store.dispatch("code/CODE_LOAD", "B20000,B10000,B40000").then(ret => this.code = ret);
  */
  CODE_LOAD (context, payload) {

    const vm = this._vm
    const ui = vm.$ui

    // console.log("vm.$api =", vm.$api );
    // console.log("payload =", payload );

    return new Promise((resolve, reject) => {

      vm.$http.get(vm.$api + '/public/common/commonCode', { params: {codeList : payload}})
        .then(ret => {
          resolve(ret.data)
        }).catch(e=>{
          ui.procError(e)
          reject(e)
        })


      // setTimeout(() => {
      //   commit('someMutation')
      //   resolve()
      // }, 1000)
    })
  },
}

export default {
  namespaced: true,
  state,     // $store.state.session.user.no
  getters,   // $store.getters["session/user"].no
  mutations, // $store.commit("session.SET_USER", user)
  actions,   // $store.dispatch("session.LOGGED_OUT")
}
